var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-content"},[_c('div',[(_vm.feedLoaded)?_c('gmap-map',{ref:"map",staticStyle:{"width":"100%","height":"500px"},attrs:{"center":_vm.center,"zoom":_vm.zoom,"lang":'en',"options":_vm.options}},_vm._l((_vm.locations),function(m,index){return _c('gmap-marker',{key:index,attrs:{"draggable":true,"position":{
             lat: parseFloat(m.lat),
             lng: parseFloat(m.lng)
        }}})}),1):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }